import { render, staticRenderFns } from "./SideMenuFront.vue?vue&type=template&id=32b4757d&scoped=true"
import script from "./SideMenuFront.vue?vue&type=script&lang=js"
export * from "./SideMenuFront.vue?vue&type=script&lang=js"
import style0 from "./SideMenuFront.vue?vue&type=style&index=0&id=32b4757d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4757d",
  null
  
)

export default component.exports